import classNames from "classnames";

const spinAnimation = {
  animation: 'spin 2s infinite steps(180)',
  transformOrigin: 'center'
};

const keyframes = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;

export default function LoaderIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <>
      <style>{keyframes}</style>
      <span 
        className={classNames(className, 'inline-flex items-center justify-center')} 
        style={spinAnimation}
        onClick={onClick}
      >
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="loader">
            <path id="Vector (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M9.99935 1.3335C10.4596 1.3335 10.8327 1.70659 10.8327 2.16683V5.50016C10.8327 5.9604 10.4596 6.3335 9.99935 6.3335C9.53911 6.3335 9.16602 5.9604 9.16602 5.50016V2.16683C9.16602 1.70659 9.53911 1.3335 9.99935 1.3335Z" fill="currentColor"/>
            <path id="Vector (Stroke)_2" fillRule="evenodd" clipRule="evenodd" d="M9.99935 14.6665C10.4596 14.6665 10.8327 15.0396 10.8327 15.4998V18.8332C10.8327 19.2934 10.4596 19.6665 9.99935 19.6665C9.53911 19.6665 9.16602 19.2934 9.16602 18.8332V15.4998C9.16602 15.0396 9.53911 14.6665 9.99935 14.6665Z" fill="currentColor"/>
            <path id="Vector (Stroke)_3" fillRule="evenodd" clipRule="evenodd" d="M3.51947 4.01898C3.84491 3.69354 4.37254 3.69354 4.69798 4.01898L7.05631 6.37731C7.38175 6.70275 7.38175 7.23039 7.05631 7.55583C6.73088 7.88126 6.20324 7.88126 5.8778 7.55583L3.51947 5.19749C3.19403 4.87205 3.19403 4.34442 3.51947 4.01898Z" fill="currentColor"/>
            <path id="Vector (Stroke)_4" fillRule="evenodd" clipRule="evenodd" d="M12.9433 13.4443C13.2687 13.1188 13.7964 13.1188 14.1218 13.4443L16.4801 15.8026C16.8056 16.128 16.8056 16.6557 16.4801 16.9811C16.1547 17.3066 15.6271 17.3066 15.3016 16.9811L12.9433 14.6228C12.6179 14.2973 12.6179 13.7697 12.9433 13.4443Z" fill="currentColor"/>
            <path id="Vector (Stroke)_5" fillRule="evenodd" clipRule="evenodd" d="M0.833984 10.4998C0.833984 10.0396 1.20708 9.6665 1.66732 9.6665H5.00065C5.46089 9.6665 5.83398 10.0396 5.83398 10.4998C5.83398 10.9601 5.46089 11.3332 5.00065 11.3332H1.66732C1.20708 11.3332 0.833984 10.9601 0.833984 10.4998Z" fill="currentColor"/>
            <path id="Vector (Stroke)_6" fillRule="evenodd" clipRule="evenodd" d="M14.166 10.4998C14.166 10.0396 14.5391 9.6665 14.9993 9.6665H18.3327C18.7929 9.6665 19.166 10.0396 19.166 10.4998C19.166 10.9601 18.7929 11.3332 18.3327 11.3332H14.9993C14.5391 11.3332 14.166 10.9601 14.166 10.4998Z" fill="currentColor"/>
            <path id="Vector (Stroke)_7" fillRule="evenodd" clipRule="evenodd" d="M7.05631 13.4443C7.38175 13.7697 7.38175 14.2973 7.05631 14.6228L4.69798 16.9811C4.37254 17.3066 3.84491 17.3066 3.51947 16.9811C3.19403 16.6557 3.19403 16.128 3.51947 15.8026L5.8778 13.4443C6.20324 13.1188 6.73088 13.1188 7.05631 13.4443Z" fill="currentColor"/>
            <path id="Vector (Stroke)_8" fillRule="evenodd" clipRule="evenodd" d="M16.4801 4.01898C16.8056 4.34442 16.8056 4.87205 16.4801 5.19749L14.1218 7.55583C13.7964 7.88126 13.2687 7.88126 12.9433 7.55583C12.6179 7.23039 12.6179 6.70275 12.9433 6.37731L15.3016 4.01898C15.6271 3.69354 16.1547 3.69354 16.4801 4.01898Z" fill="currentColor"/>
          </g>
        </svg>
      </span>
    </>
  );
}
